import React, { useEffect, useState, lazy, Suspense } from "react";
import Modal from 'react-modal';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';

const OnDeffImplementation = lazy(() => import('./on-deff-implementation'))

const QuoteRequestModalBlog = (props) => {
    const proId = props.proid;
    const startVisible = props.startVisible ? true : false;
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(startVisible)
    const changeShowModal = () => {
        setShowModal(!showModal)
    }

    let initialValuePoolLimit = 0;
    if (typeof window !== 'undefined') {
        const params = new URLSearchParams(window.location.search)
        if (params.get("test") == "true") {
            initialValuePoolLimit = 1;
        }
    }
    const [limitPoolSize, setPoolTest] = useState(initialValuePoolLimit)

    const [modalStyles, setModalStyles] = useState(
        {
            content:
            {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                borderRadius: '10px',
                border: 'none',
                backgroundColor: '#e8e8e8',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                padding: '0px 20px',
                minHeight: 'auto',
                width: '600px',
            }
        })

    return (
        <>
            {props.showButton && <a href="#" className="service-blog" data-keygroup={props.code} onClick={changeShowModal}>{props.title}</a>}
            <Modal
                id={1}
                isOpen={showModal}
                style={modalStyles}
                contentLabel="Get a Quote!"
                shouldCloseOnOverlayClick={false}
                preventScroll={true}
                ariaHideApp={false}
            >
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={loading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <div className="modal-header">
                    <button type="button" className="close closermodal" onClick={changeShowModal} aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div id="quote-steps-modal-library">
                  <Suspense fallback={<h1>Loading…</h1>}>
                    <OnDeffImplementation
                        initialData={[{ key: 'pro_id', value: proId },{ key: 'limit_poolsize', value: limitPoolSize }]}
                        formCode={props.ondeffCode}
                        loadingFunction={setLoading}>
                    </OnDeffImplementation>
                  </Suspense>
                </div>
                <div id="temp"></div>
            </Modal></>
    )
}

export default QuoteRequestModalBlog;